export default __webpack_public_path__ + "static/media/BB_35.95435a64.png";